import {IStory} from '../../constants'
export function filterCatalog(stories: IStory[], {query = '', categoryIds = null, curriculumIds = null, metaIds = null, selectedIds = null}: {
  query?: string; categoryIds?: number[] | null; curriculumIds?: number[] | null; metaIds?: number[] | null; selectedIds?: number[] | null
}) {
  const term = query.trim().toLocaleLowerCase('tr-TR')
  return stories.filter(story => story.storyId !== 214 && (!term || story.title.toLocaleLowerCase('tr-TR').includes(term)) &&
    [categoryIds, curriculumIds, metaIds, selectedIds].every(ids => ids === null || ids.includes(story.storyId)))
    .sort((a, b) => a.title.localeCompare(b.title, 'tr'))
}
